import { CoreIcon } from '../core-icon';
import addSVG from '../../assets/icons/add.svg';
import type { IconProps } from '../core-icon';

export const AddIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={addSVG} {...props} />;
};
